export enum RequestStatus {
    init,
    needCompleteData,
    chatUsing,
    // pending, // for Care request // KR remove , it integrate into processing
    processing,
    finish = 50,
    cancel,
}

export const RequestStatusName = [
    {
        RequestStatus: RequestStatus.init,
        Name: '已建立'
    },
    {
        RequestStatus: RequestStatus.needCompleteData,
        Name: '待補件',
    },
    {
        RequestStatus: RequestStatus.chatUsing,
        Name: 'AI諮詢使用中',
    },
    {
        RequestStatus: RequestStatus.processing,
        Name: '處理中',
    },
    {
        RequestStatus: RequestStatus.finish,
        Name: '已完成',
    },
    {
        RequestStatus: RequestStatus.cancel,
        Name: '已取消',
    },
]

export enum RequestType {
    custom,
    aiConsult,
    care
}

export enum PlanType {
    none,
    freeTrial,
    personal,
    group,
    customGroup // for company or lots users.
}

export const Tiers = [
    {
        name: '無',
        planType: PlanType.none,
        show: false,
        href: '#',
        price: '$0',
        description: '請選擇',
        features: [],
        aiChatNumbers: 0,
        careNumbers: 0,
    },
    {
        name: '免費試用一個月',
        planType: PlanType.freeTrial,
        show: true,
        href: '#',
        price: '$0',
        description: '新註冊帳號適用 ! 讓您體驗我們的強大功能，帶領您走向下一個業務高峰 ! ',
        features: [' 10 個 AI 聊天室', ' 3 次關懷'],
        aiChatNumbers: 10,
        careNumbers: 3,
    },
    {
        name: '單人方案',
        planType: PlanType.personal,
        show: true,
        href: '#',
        price: '$970 / 月',
        description: '提供您合適的AI聊天室數量與關懷數量，適合兼職業務使用。',
        features: ['每月 100 個 AI 聊天室', '每月 10 次關懷'],
        aiChatNumbers: 100,
        careNumbers: 10,
    },
    {
        name: '團體6人',
        planType: PlanType.group,
        show: true,
        href: '#',
        price: '$300 /月/人',
        description: '6人方案，包含所有單人方案的內容，加上更有競爭力的個人網頁，給您更有競爭力的價格 ! ',
        features: ['每人每月 100 個 AI 聊天室', '個人網頁服務', '每人每月 30 次關懷'],
        aiChatNumbers: 100,
        careNumbers: 30,
    },
]

export interface ChatViewModel {
    date: Date,
    isSendByUser: boolean,
    message: string // notice the <br/> or \n issue
}

// ------------Following are temp data class, will replace them when make sure and use Hasura class instead.----------

// export const requestList = [
//     {
//         id: '779218ea-34fe-4ada-9024-aedaceb81eeb',
//         startDate: new Date('2023-06-13'),
//         expiredDate: new Date('2023-06-14'),
//         inChargePerson: '王業務',
//         status: requestStatus.finish,
//         type: requestType.aiConsult,
//         aiChatHistory: {
//             id: 1,
//             createDate: new Date('2023-06-14'),
//             belongUserId: '',
//             chats: [
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '您好，我是AI諮詢醫師，請問您今天要諮詢什麼 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: true,
//                     message: 'Hi, 我想請問一下醫生說我胃中有東西，是否說明我會有一些癌症的可能性 ? ',

//                 } as chatViewModel,
//                 {
//                     date: new Date('2023-06-14'),
//                     isSendByUser: false,
//                     message: '我這邊目前無法僅憑此說明就能確定。請問是否有其他資訊如同診斷證明可以傳給我分析 ? ',

//                 } as chatViewModel,
//             ],
//         } as aiChatHistoryViewModel,
//     },
// ]

// export default requestStatus

